module.exports = __webpack_public_path__ + "static/product-3-4ee3d8da22cbc72b2a86e629d899faad.png";